export default "__VITE_ASSET__Dnr8WPPe__"